import {isRtl} from 'scratch-l10n';
import editorMessages from 'scratch-l10n/locales/editor-msgs';

const messagesByLocale = {
    ...editorMessages,
    pl: {
        ...editorMessages.pl,
        'gui.confirmationPrompt.confirm': 'tak',
        'gui.confirmationPrompt.cancel': 'nie',
        'gui.menuBar.undo': 'Cofnij',
        'gui.menuBar.redo': 'Ponów',
        'gui.generatedImage.sprite': 'Wygeneruj duszka',
        'gui.generatedImage.costume': 'Wygeneruj kostium',
        'gui.generatedImage.backdrop': 'Wygeneruj tło',
        'gui.costumeTab.generateBackdrop': 'Wygeneruj tło',
        'gui.customProcedures.returnType': 'Typ zwracanych danych',
        'gui.customProcedures.commandType': 'brak',
        'gui.customProcedures.valueType': 'liczba lub tekst',
        'gui.customProcedures.booleanType': 'wartość logiczna',
        'gui.customProcedures.booleanReturnType': 'wartość logiczna'
    },
    es: {
        ...editorMessages.es,
        'gui.generatedImage.sprite': 'Generar objeto',
        'gui.generatedImage.costume': 'Generar disfraz',
        'gui.generatedImage.backdrop': 'Generar fondo',
        'gui.costumeTab.generateBackdrop': 'Generar fondo'
    }
};

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale,
    messages: messagesByLocale.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: isRtl(action.locale),
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (Object.prototype.hasOwnProperty.call(currentState.messagesByLocale, locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: isRtl(locale),
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
